/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeAttachPhoneStartRequest
 */
export interface MeAttachPhoneStartRequest {
    /**
     * 
     */
    phone: string;
}

/**
 * Check if a given object implements the MeAttachPhoneStartRequest interface.
 */
export function instanceOfMeAttachPhoneStartRequest(value: object): value is MeAttachPhoneStartRequest {
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function MeAttachPhoneStartRequestFromJSON(json: any): MeAttachPhoneStartRequest {
    return MeAttachPhoneStartRequestFromJSONTyped(json, false);
}

export function MeAttachPhoneStartRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeAttachPhoneStartRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'phone': json['phone'],
    };
}

export function MeAttachPhoneStartRequestToJSON(json: any): MeAttachPhoneStartRequest {
    return MeAttachPhoneStartRequestToJSONTyped(json, false);
}

export function MeAttachPhoneStartRequestToJSONTyped(value?: MeAttachPhoneStartRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phone': value['phone'],
    };
}

